// extracted by mini-css-extract-plugin
export default {"burger":"burger-icon_burger__7uJBZ","line1":"burger-icon_line1__Mh4w8","line2":"burger-icon_line2__CCLkG","line3":"burger-icon_line3__JMTV3","opened":"burger-icon_opened__QMs4B"};